import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-menu",
  "use": "icon-menu-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-menu\">\r\n    <defs>\r\n        <style></style>\r\n    </defs>\r\n    <path d=\"M162.352 162.352h87.488v87.488h-87.488v-87.488zM291.254 162.352h570.394v87.488H291.254v-87.488zM162.352 468.256h87.488v87.488h-87.488v-87.488zM291.254 468.256h570.394v87.488H291.254v-87.488zM162.352 775.335h87.488v87.488h-87.488v-87.488zM291.254 775.335h570.394v87.488H291.254v-87.488z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol